var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoUnlock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.83799 0.195312C7.09451 0.195312 5.67603 1.61374 5.67603 3.35728V4.73142H0.690044C0.308968 4.73142 0 5.04034 0 5.42146V11.1165C0 11.4977 0.308968 11.8066 0.690044 11.8066H7.76165C8.14277 11.8066 8.4517 11.4977 8.4517 11.1165V5.42146C8.4517 5.04034 8.14277 4.73142 7.76165 4.73142H7.38781V3.35728C7.38781 2.55764 8.03836 1.90705 8.83804 1.90705C9.63772 1.90705 10.2883 2.5576 10.2883 3.35728C10.2883 3.82997 10.6715 4.21315 11.1442 4.21315C11.6169 4.21315 12 3.82997 12 3.35728C12 1.61379 10.5815 0.195312 8.83799 0.195312ZM4.89625 8.33612V9.46724C4.89625 9.83749 4.5961 10.1376 4.22585 10.1376C3.8556 10.1376 3.55545 9.83749 3.55545 9.46724V8.33612C3.30361 8.1376 3.14172 7.83005 3.14172 7.48449C3.14172 6.88573 3.62708 6.40036 4.22585 6.40036C4.82462 6.40036 5.30998 6.88573 5.30998 7.48449C5.30998 7.83005 5.14809 8.1376 4.89625 8.33612Z",
    fill: "#24FFF2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoUnlock);
export default __webpack_public_path__ + "static/media/ico-unlock.8fe8ef24cacd875986078d631edc3b57.svg";
export { ForwardRef as ReactComponent };